<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>

      <v-container fluid>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <template
            v-if="
              this.$store.getters.usuario.idRol == 2 ||
              this.$store.getters.usuario.idRol == 5
            "
          >
            <v-row justify="center" class="mt-4">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="contratistaSeleccion"
                  :items="contratistas"
                  item-value="idContratista"
                  item-text="descripcionContratista"
                  :menu-props="{ maxHeight: '400' }"
                  :rules="[Validaciones.requerido]"
                  :readonly="readonlyContrator"
                  prepend-icon="mdi-badge-account-outline"
                  :label="SeleccionContratista"
                  no-data-text="No se encontraron contratistas"
                  hint="Seleccione un contratista"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>
          </template>
          <template
            v-if="
              this.$store.getters.usuario.idRol == 3 ||
              (this.$store.getters.usuario.idRol == 5 && tipoOperacion == 2)
            "
          >
            <v-row justify="center" class="mt-4">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="cuadrillaSeleccion"
                  :items="cuadrillas"
                  item-value="idCuadrilla"
                  item-text="cuadrilla"
                  :menu-props="{ maxHeight: '400' }"
                  :rules="[Validaciones.requerido]"
                  :readonly="readonlyContrator"
                  prepend-icon="mdi-badge-account-outline"
                  no-data-text="No se encontraron cuadrillas"
                  :hint="hintContratista"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>
          </template>
        </v-form>
        <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>

        <template v-if="this.$store.getters.usuario.idRol == 2">
          <template v-if="colorDialogTitle == 'purple'">
            <v-btn color="blue darken-1" text @click="asignarTodasTareas()"
              >Asignar Todas Las Tareas</v-btn
            >
          </template>
          <template v-if="colorDialogTitle == 'green'">
            <v-btn color="blue darken-1" text @click="asignarTarea()"
              >Asignar</v-btn
            >
          </template>
        </template>

        <template v-if="this.$store.getters.usuario.idRol == 3">
          <v-btn
            color="blue darken-1"
            text
            @click="asignarTareaCuadrillaConfirmacion()"
            >Asignar</v-btn
          >
        </template>

        <template
          v-if="this.$store.getters.usuario.idRol == 5 && tipoOperacion == 1"
        >
          <v-btn color="blue darken-1" text @click="asignarTarea()"
            >Asignar Tarea al Contratista</v-btn
          >
        </template>

        <template
          v-if="this.$store.getters.usuario.idRol == 5 && tipoOperacion == 2"
        >
          <v-btn
            color="blue darken-1"
            text
            @click="asignarTareaCuadrillaConfirmacion()"
            >Asignar Tarea a la cuadrilla</v-btn
          >
        </template>

        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      </v-card-actions>

      <dialog-mensaje ref="dialogMensaje" @resultado="resultado" />
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      tipoOperacion: "",
      listaTareasSeleccionadas: [],
      cuadrillas: [],
      idTarea: "",
      cuadrillaSeleccion: "",
      formTitle: "",
      datosTarea: "",
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdCuadrilla: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdCuadrilla === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdCuadrilla === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdCuadrilla > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },
  watch: {
    isSaving(val) {
      if (val) {
        setTimeout(() => (this.isSaving = false), 1500);
      } else {
        this.submitForm();
      }
    },
    async contratistaSeleccion() {
      if (this.$store.getters.usuario.idRol == 5) {
        console.log("cambio el contratista");
        console.log(this.contratistaSeleccion);
        this.$store.getters.usuario.idContratista = this.contratistaSeleccion;
        await this.getListarCuadrillaByContratista();
      }
    },
  },
  mounted() {
    if (this.$store.getters.usuario.idRol === 3) {
      console.log("Ingreso con la cuenta de un contratista");
      this.contratistaSeleccion = this.$store.getters.idContratista;
      //this.getListarEmpleadosContratistasinCuadrillaAsignada();
      //this.getListarCuadrilla();
      //this.getListarCuadrillaContratista();
      this.getListarCuadrillaByContratista();
    } else {
      this.getListarContratistas();
    }

    if (this.$store.getters.usuario.idRol === 5) {
      this.getListarCuadrillaByContratista();
      this.getListarContratistas();
    }

    //this.getListarContratistas();
  },
  computed: {
    // formTitle() {
    //   //   return this.tipoModal_IdCuadrilla === 0
    //   //     ? "Crear Cuadrilla"
    //   //     : "Editar Cuadrilla Nro.: " + this.tipoModal_IdCuadrilla;
    //   return "Seleccione un Contratista para Asignarle la cuadrilla";
    // },
    txtEmpleado() {
      return this.empleadoSeleccionados.length - 2 == 1
        ? "+1 empleado"
        : "+" +
            (this.empleadoSeleccionados.length - 2).toString() +
            " empleados";
    },
  },
  methods: {
    async getListarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    asignarTodasTareaContratista(datos) {
      //this.formTitle =
      console.log("Ingreso en asignar todas tarea contratista");
      this.colorDialogTitle = "purple";
      this.formTitle = "Seleccione una contratista para asignarle las tareas";
      console.log("Los datos de la tarea son: ");
      console.log(datos);
      this.datosTarea = datos;
      this.idTarea = datos.idTarea;
      this.listaTareasSeleccionadas = datos;
      this.dialog = true;
    },

    async asignarTodasTareas() {
      console.log("El token es");
      console.log(this.$store.getters.usuario.token);

      this.url = this.$store.getters.urlBase + "Task/ingresarTareas";

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.getters.usuario.token}`,
        },
      };

      var tareas = [];

      console.log("Antes de recorrer la tablaTareas");
      console.log(this.listaTareasSeleccionadas);

      for (var i = 0; i < this.listaTareasSeleccionadas.length; i++) {
        tareas.push({
          distrito: this.listaTareasSeleccionadas[i].distrito,
          radio: this.listaTareasSeleccionadas[i].radio,
          recorrido: this.listaTareasSeleccionadas[i].recorrido,
          identificador:
            this.listaTareasSeleccionadas[i].identificador.toString(),
          fechaAlta: this.convertirFecha(
            this.listaTareasSeleccionadas[i].inicioTarea
          ),
          vencimiento: this.convertirFecha(
            this.listaTareasSeleccionadas[i].vencimiento
          ),
          titular: this.listaTareasSeleccionadas[i].titular,
          domicilio: this.listaTareasSeleccionadas[i].domicilio,
          barrio: this.listaTareasSeleccionadas[i].barrio,
          medidor:
            this.listaTareasSeleccionadas[i].medidor == null
              ? 0
              : this.listaTareasSeleccionadas[i].medidor,
          motivo: this.listaTareasSeleccionadas[i].motivo,
          detalle: this.listaTareasSeleccionadas[i].detalle,
          comentario: this.listaTareasSeleccionadas[i].comentario,
          telefono:
            this.listaTareasSeleccionadas[i].telefono == null
              ? null
              : this.listaTareasSeleccionadas[i].telefono.toString(),
          email: this.listaTareasSeleccionadas[i].mail,
          ultimoIndice: this.listaTareasSeleccionadas[i].indice,
          idContratista: this.contratistaSeleccion,
          ISN: this.listaTareasSeleccionadas[i].isn,
          idUsuario: this.$store.getters.usuario.user_id,
        });
      }

      // this.tablaTareas.forEach((tarea) => {
      //   tareas.push({
      //     distrito: tarea.distrito,
      //     radio: tarea.radio,
      //     recorrido: tarea.recorrido,
      //     identificador: tarea.identificador.toString(),
      //     vencimiento: this.convertirFecha(tarea.vencimiento),
      //     titular: tarea.titular,
      //     domicilio: tarea.domicilio,
      //     barrio: tarea.barrio,
      //     medidor: tarea.medidor == null ? 0 : tarea.medidor,
      //     motivo: tarea.motivo,
      //     detalle: tarea.detalle,
      //     comentario: tarea.comentario,
      //     telefono: tarea.telefono == null ? null : tarea.telefono.toString(),
      //     email: tarea.mail,
      //     ultimoIndice: tarea.indice,
      //     idContratista: this.contratistaSeleccion,
      //     ISN: tarea.isn,
      //   });
      // });

      const data = {
        listaTareas: tareas,
      };

      console.log("Los datos para ingresar tarea son: ");
      console.log(data);

      //var listacontratista = [];
      //this.contratistas = listacontratista;

      var respuesta = await axios
        .post(this.url, data, config)
        .then((response) => {
          console.log("La lista de tareas del contratista es: ");
          console.log(response);
          return response;
          //this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
          return null;
        });

      console.log("La respuesta es");
      console.log(respuesta);

      if (respuesta.status == 200) {
        this.mensajeDelDialog = respuesta.data;

        var mensajeDialog = "";
        if (this.mensajeDelDialog == true) {
          mensajeDialog = "Operacion Exitosa";
        } else {
          mensajeDialog = "Operacion Rechazada";
        }

        this.$refs.dialogMensaje.abrirMensajeDialog(
          mensajeDialog,
          1,
          this.mensajeDelDialog == true ? "green" : "red",
          "Informacion"
        );
      } else {
        console.log("Ingreso en el else de la respuesta");
        this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
        this.mensajeDelDialog = respuesta.Error;
        this.mensajeDelDialog = respuesta.Error.split("-");
        this.colorDialog = "red";
        this.dialog = true;
      }
      this.dialog = false;

      console.log("Antes de recargar el listado");
      this.$emit("recargarListado");
    },

    async asignarTarea() {
      console.log("El token es");
      console.log(this.$store.getters.usuario.token);

      this.url = this.$store.getters.urlBase + "Task/ingresarTarea";

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.getters.usuario.token}`,
        },
      };

      const data = {
        distrito: this.datosTarea.distrito,
        radio: this.datosTarea.radio,
        recorrido: this.datosTarea.recorrido,
        identificador: this.datosTarea.identificador.toString(),
        fechaAltaT: this.convertirFecha(this.datosTarea.inicioTarea),
        vencimiento: this.convertirFecha(this.datosTarea.vencimiento),
        titular: this.datosTarea.titular,
        domicilio: this.datosTarea.domicilio,
        barrio: this.datosTarea.barrio,
        medidor: this.datosTarea.medidor == null ? 0 : this.datosTarea.medidor,
        motivo: this.datosTarea.motivo,
        detalle: this.datosTarea.detalle,
        comentario: this.datosTarea.comentario,
        telefono:
          this.datosTarea.telefono == null
            ? null
            : this.datosTarea.telefono.toString(),
        email: this.datosTarea.mail,
        ultimoIndice: this.datosTarea.indice,
        idContratista: this.contratistaSeleccion,
        ISN: this.datosTarea.isn,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los datos para ingresar tarea son: ");
      console.log(data);

      //var listacontratista = [];
      //this.contratistas = listacontratista;

      var respuesta = await axios
        .post(this.url, data, config)
        .then((response) => {
          console.log("La lista de tareas del contratista es: ");
          console.log(response);
          return response;
          //this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
          return null;
        });

      console.log("La respuesta es");
      console.log(respuesta);

      if (respuesta.status == 200) {
        this.mensajeDelDialog = respuesta.data;

        var mensajeDialog = "";
        if (this.mensajeDelDialog == true) {
          mensajeDialog = "Operacion Exitosa";
        } else {
          mensajeDialog = "Operacion Rechazada";
        }

        this.$refs.dialogMensaje.abrirMensajeDialog(
          mensajeDialog,
          1,
          this.mensajeDelDialog == true ? "green" : "red",
          "Informacion"
        );
      } else {
        console.log("Ingreso en el else de la respuesta");
        this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
        this.mensajeDelDialog = respuesta.Error;
        this.mensajeDelDialog = respuesta.Error.split("-");
        this.colorDialog = "red";
        this.dialog = true;
      }
      this.dialog = false;

      console.log("Antes de recargar el listado");
      this.$emit("recargarListado");
    },
    convertirFecha(fecha) {
      console.log("Entro en convertir fecha");
      console.log(fecha);
      const year = fecha.substring(0, 4);
      const month = fecha.substring(4, 6);
      const day = fecha.substring(6, 8);

      console.log("LAs fechas convertidas son");
      console.log(fecha);
      console.log(day);
      console.log(month);
      console.log(year);

      const formattedDate = day + "/" + month + "/" + year;
      console.log(formattedDate);
      return formattedDate;
    },
    pruebaReset() {
      this.$refs.form.reset();
    },
    openModal(datos) {
      this.datosTarea = datos;
      this.colorDialogTitle = "green";
      //this.tipoModal_IdCuadrilla = tipo;
      //   if (this.tipoModal_IdCuadrilla != 0) {
      //     this.getCuadrillabyID(tipo);
      //   } else {
      //     this.empleados = [];
      //     this.contratistaSeleccion = [];
      //   }
      this.formDialog = "Seleccione un contratista para asignarle la tarea";
      console.log("Los datos de la tarea son");
      console.log(this.datosTarea);
      console.log(this.datosTarea.identificador);
      this.dialog = true;
    },
    openModalModificacion(datos) {
      this.colorDialogTitle = "green";
      console.log("Los datos de la cuadrilla enviada son: " + datos);
      console.log(datos);
      this.tipoModal_IdCuadrilla = datos.idCuadrilla;
      if (this.tipoModal_IdCuadrilla != 0) {
        this.getCuadrillabyID(datos.idCuadrilla);
      } else {
        this.empleados = [];
        this.contratistaSeleccion = [];
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.tipoModal_IdCuadrilla = 0;
      this.$refs.form.reset();
    },
    submitForm() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit("Recargar");
    },
    async getListarContratistas() {
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      var listacontratista = [];
      this.contratistas = listacontratista;

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },
    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    async getListarCuadrillaByContratista() {
      console.log("getListarCuadrillaByContratista");
      console.log(this.$store.getters.usuario.idContratista);
      console.log(this.$store.getters.usuario.user_id);

      // Construir la URL con parámetros de consulta
      const idUsuario = this.$store.getters.usuario.user_id;
      const idEmpresa = this.$store.getters.usuario.idContratista;

      this.url = `${this.$store.getters.urlBase}Cuadrilla?idUsuario=${idUsuario}&idEmpresa=${idEmpresa}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      console.log("La url es: ");
      console.log(this.url);

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarCuadrillaContratista() {
      this.url =
        this.$store.getters.urlBase + "Gang/GetActiveGangByIdContractor";

      this.url =
        this.$store.state.urlBase +
        "Gang/GetActiveGangByIdContractor?idContractor=" +
        this.$store.getters.usuario.idContratista;

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    asignarTareaCuadrilla(datos) {
      //this.formTitle =
      console.log("Ingreso en asignar tarea cuadrilla");
      this.hintContratista = "Seleccione una cuadrilla";
      this.colorDialogTitle = "orange";
      this.formTitle = "Seleccione una cuadrilla para asignarle la tarea";
      console.log("Los datos de la tarea son: ");
      console.log(datos);
      this.tipoOperacion = 2;
      this.datosTarea = datos;
      this.idTarea = datos.idTarea;
      this.dialog = true;
    },

    asignarTareaContratista(datos) {
      //this.formTitle =
      console.log("Ingreso en asignar tarea contratista");
      this.colorDialogTitle = "green";
      this.formTitle = "Seleccione una contratista para asignarle la tarea";
      console.log("Los datos de la tarea son: ");
      console.log(datos);
      this.tipoOperacion = 1;
      this.datosTarea = datos;
      this.idTarea = datos.idTarea;
      this.dialog = true;
    },

    async asignarTareaCuadrillaConfirmacion() {
      console.log("El token es");
      console.log(this.$store.getters.usuario.token);

      this.url = this.$store.getters.urlBase + "Task/ingresarTareaCuadrilla";

      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      console.log("El id de la cuadrilla es ");
      console.log(this.cuadrillaSeleccion);

      if (this.cuadrillaSeleccion == null || this.cuadrillaSeleccion == "") {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha seleccionado una cuadrilla para asignarle la tarea",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      const data = {
        idTarea: this.idTarea,
        idCuadrilla: this.cuadrillaSeleccion,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los datos para ingresar tarea son: ");
      console.log(data);

      //var listacontratista = [];
      //this.contratistas = listacontratista;

      var respuesta = await axios
        .post(this.url, data)
        .then((response) => {
          console.log("La lista de tareas del contratista es: ");
          console.log(response);
          return response;
          //this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
          return null;
        });

      console.log("La respuesta es");
      console.log(respuesta);

      if (respuesta.status == 200) {
        this.mensajeDelDialog = respuesta.data;

        var mensajeDialog = "";
        if (this.mensajeDelDialog == true) {
          mensajeDialog = "Operacion Exitosa";
        } else {
          mensajeDialog = "Operacion Rechazada";
        }

        this.$refs.dialogMensaje.abrirMensajeDialog(
          mensajeDialog,
          1,
          this.mensajeDelDialog == true ? "green" : "red",
          "Informacion"
        );
      } else {
        console.log("Ingreso en el else de la respuesta");
        this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
        this.mensajeDelDialog = respuesta.Error;
        this.mensajeDelDialog = respuesta.Error.split("-");
        this.colorDialog = "red";
        this.dialog = true;
      }

      if (this.bandera == 1) {
        console.log("Ingresoe en la bandera 1 para ocultar el dialog");
        this.dialog = false;
      }

      this.loadingButton = false;

      this.dialog = false;

      console.log("antes de recargar el listado de tareas despues de asignar ");

      this.$emit("recargarListadoAsignados");
    },

    async getListarEmpleadosContratistasinCuadrillaAsignada() {
      console.log("El contratista seleccionado es");
      console.log(this.contratistaSeleccion);

      this.url = this.$store.getters.urlBase + "Employee/getlistByContrator";
      // this.$store.getters.urlBase + "Employee/getlistByContrator";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: {
          idcontratista:
            this.$store.getters.usuario.idRol != 3
              ? this.contratistaSeleccion
              : this.$store.getters.idContratista,
          idDistrito: this.$store.getters.usuario.idDistrito,
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      console.log("Los empleado del contratista son");
      console.log(respuesta.data);

      if (respuesta.status === 200) {
        this.empleados = respuesta.data;
      }
    },
    async getCuadrillabyID(idCuadrilla) {
      this.url = this.$store.getters.urlBase + "Gang/GetActiveGangById";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: { idGang: idCuadrilla },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        this.contratistaSeleccion = respuesta.data.idEmpresa;
        this.Usuario = respuesta.data.cuenta;
        this.NroOT = respuesta.data.idOT;
        console.log(respuesta.data);
        await this.getListarEmpleadosContratistasinCuadrillaAsignada();

        respuesta.data.empleados.forEach((element) => {
          this.empleados.push({
            idEmpleado: element.dni,
            nombreCompleto: element.apellido + " " + element.nombre,
          });
          this.empleadoSeleccionados.splice(1, 0, element.dni);
        });
      } else {
        this.colorSnack = "red";
        this.mensajeSnack = respuesta.data;
        this.Showsnackbar = true;
      }
    },
    OptionSave() {
      if (this.tipoModal_IdCuadrilla === 0) {
        console.log(this.empleadoSeleccionados);
        this.InsertarCuadrilla();
      } else {
        console.log(this.empleadoSeleccionados);
        this.UpdateCuadrilla();
      }
    },
    async UpdateCuadrilla() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/updategang";

        var gangModel = {
          GangID: this.tipoModal_IdCuadrilla,
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.NroOT,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.usuario.token}`,
          },
        };
        await axios
          .post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
    async InsertarCuadrilla() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/insertgang";

        var gangModel = {
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.NroOT,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.usuario.token}`,
          },
        };
        await axios
          .post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
  },
};
</script>
